const bank = [
  { key: '002', value: 'BANAMEX' },
  { key: '006', value: 'BANCOMEXT' },
  { key: '009', value: 'BANOBRAS' },
  { key: '012', value: 'BBVA BANCOMER' },
  { key: '014', value: 'SANTANDER' },
  { key: '019', value: 'BANJERCITO' },
  { key: '021', value: 'HSBC' },
  { key: '030', value: 'BAJIO' },
  { key: '032', value: 'IXE' },
  { key: '036', value: 'INBURSA' },
  { key: '037', value: 'INTERACCIONES' },
  { key: '042', value: 'MIFEL' },
  { key: '044', value: 'SCOTIABANK' },
  { key: '058', value: 'BANREGIO' },
  { key: '059', value: 'INVEX' },
  { key: '060', value: 'BANSI' },
  { key: '062', value: 'AFIRME' },
  { key: '072', value: 'BANORTE/IXE' },
  { key: '102', value: 'THE ROYAL BANK' },
  { key: '103', value: 'AMERICAN EXPRESS' },
  { key: '106', value: 'BAMSA' },
  { key: '108', value: 'TOKYO' },
  { key: '110', value: 'JP MORGAN' },
  { key: '112', value: 'BMONEX' },
  { key: '113', value: 'VE POR MAS' },
  { key: '116', value: 'ING' },
  { key: '124', value: 'DEUTSCHE' },
  { key: '126', value: 'CREDIT SUISSE' },
  { key: '127', value: 'AZTECA' },
  { key: '128', value: 'AUTOFIN' },
  { key: '129', value: 'BARCLAYS' },
  { key: '130', value: 'COMPARTAMOS' },
  { key: '131', value: 'BANCO FAMSA' },
  { key: '132', value: 'BMULTIVA' },
  { key: '133', value: 'ACTINVER' },
  { key: '134', value: 'WAL-MART' },
  { key: '135', value: 'NAFIN' },
  { key: '136', value: 'INTERCAM BANCO' },
  { key: '137', value: 'BANCOPPEL' },
  { key: '138', value: 'ABC CAPITAL' },
  { key: '139', value: 'UBS BANK' },
  { key: '140', value: 'CONSUBANCO' },
  { key: '141', value: 'VOLKSWAGEN' },
  { key: '143', value: 'CIBANCO' },
  { key: '145', value: 'BBASE' },
  { key: '147', value: 'BANKAOOL' },
  { key: '148', value: 'PAGATODO' },
  { key: '149', value: 'FORJADORES' },
  { key: '150', value: 'INMOBILIARIO' },
  { key: '151', value: 'DONDÉ' },
  { key: '152', value: 'BANCREA' },
  { key: '153', value: 'PROGRESO' },
  { key: '154', value: 'BANCO FINTERRA' },
  { key: '155', value: 'ICBC' },
  { key: '156', value: 'SABADELL' },
  { key: '157', value: 'SHINHAN' },
  { key: '158', value: 'MIZUHO BANK' },
  { key: '159', value: 'BANK OF CHINA' },
  { key: '160', value: 'BANCO S3' },
  { key: '166', value: 'BANSEFI' },
  { key: '168', value: 'HIPOTECARIA FEDERAL' },
  { key: '600', value: 'MONEXCB' },
  { key: '601', value: 'GBM' },
  { key: '602', value: 'MASARI' },
  { key: '605', value: 'VALUE' },
  { key: '606', value: 'ESTRUCTURADORES' },
  { key: '607', value: 'TIBER' },
  { key: '608', value: 'VECTOR' },
  { key: '610', value: 'B&B' },
  { key: '614', value: 'ACCIVAL' },
  { key: '615', value: 'MERRILL LYNCH' },
  { key: '616', value: 'FINAMEX' },
  { key: '617', value: 'VALMEX' },
  { key: '618', value: 'UNICA' },
  { key: '619', value: 'MAPFRE' },
  { key: '620', value: 'PROFUTURO' },
  { key: '621', value: 'CB ACTINVER' },
  { key: '622', value: 'OACTIN' },
  { key: '623', value: 'SKANDIA' },
  { key: '626', value: 'CBDEUTSCHE' },
  { key: '627', value: 'ZURICH' },
  { key: '628', value: 'ZURICHVI' },
  { key: '629', value: 'SU CASITA' },
  { key: '630', value: 'CB INTERCAM' },
  { key: '631', value: 'CI BOLSA' },
  { key: '632', value: 'BULLTICK CB' },
  { key: '633', value: 'STERLING' },
  { key: '634', value: 'FINCOMUN' },
  { key: '636', value: 'HDI SEGUROS' },
  { key: '637', value: 'ORDER' },
  { key: '638', value: 'AKALA' },
  { key: '640', value: 'CB JPMORGAN' },
  { key: '642', value: 'REFORMA' },
  { key: '646', value: 'STP' },
  { key: '647', value: 'TELECOMM' },
  { key: '648', value: 'EVERCORE' },
  { key: '649', value: 'SKANDIA' },
  { key: '651', value: 'SEGMTY' },
  { key: '652', value: 'ASEA' },
  { key: '653', value: 'KUSPIT' },
  { key: '655', value: 'SOFIEXPRESS' },
  { key: '656', value: 'UNAGRA' },
  { key: '659', value: 'OPCIONES EMPRESARIALES DEL NOROESTE' },
  { key: '670', value: 'LIBERTAD' },
  { key: '901', value: 'CLS' },
  { key: '902', value: 'INDEVAL' },
];

module.exports = bank;
